import { calculateClientSideCorrelationContext } from '@carvana/futilities';
import { BrowserCookies } from '~/utilities';
import { logError } from '~/utilities/loggers';
import axios from './axios';
import httpWithAuth from './httpWithAuth';

export const setCorrelationContext = (userId?: string) => {
  const browserCookieId = BrowserCookies.get('BrowserCookieId');
  const correlationContext = calculateClientSideCorrelationContext(
    userId,
    browserCookieId
  );
  axios.defaults.headers.common['Correlation-Context'] = correlationContext;
  httpWithAuth.defaults.headers.common['Correlation-Context'] =
    correlationContext;
};

export const setDefaultCorrelationContext = () => {
  try {
    setCorrelationContext();
  } catch (err) {
    logError(err, { location: 'Set correlation context' });
  }
};
